import { network } from "./index";
import { CognitoAuth } from "./CognitoAuth";
import { AtticusForm } from "../models/AtticusForm";
import { FormType } from "models/FormType";
import { GeographyType } from "models/Geography";
import { KNOWLEDGE_FILLED_FORM_GENERATOR_URL } from "../constants";

export interface QueryPayload {
  geography_type?: GeographyType;
  geography_id?: number;
  form_type_id?: number;
  search_terms?: string;
  language_id?: number;
  geography_inclusive?: boolean;
}

export class FormsAPI {
  async fetchForms(queryPayload: QueryPayload): Promise<AtticusForm[] | null> {
    const fullPath = `${AtticusForm.path}/query`;
    const response = await network.callPost(fullPath, {
      geography_type: queryPayload.geography_type,
      geography_id: queryPayload.geography_id,
      form_type_id: queryPayload.form_type_id,
      search_terms: queryPayload.search_terms,
      language_id: queryPayload.language_id,
      geography_inclusive: queryPayload.geography_inclusive || true,
    });

    const forms: AtticusForm[] = [];
    response?.data?.forEach((form: any) => {
      const newForm = AtticusForm.fromJSON(form);
      forms.push(newForm);
    });
    return forms;
  }

  async getFormLimited(formId: number): Promise<AtticusForm | undefined> {
    try {
      const response = await network.callGet(
        `${AtticusForm.path}/${formId}/limited`,
        true
      );
      return AtticusForm.fromJSON(response?.data);
    } catch (error) {
      CognitoAuth.handleError(error, "getFormLimited error");
      return undefined;
    }
  }

  fetchSignedUrl(
    formKey: string,
    formId: number,
    filename: string,
  ): string {
    const queryComponents:string[] = [
      "s3_key=" + encodeURIComponent(formKey),
      "form_id=" + formId.toString(),
      "filename=" + encodeURIComponent(filename), // The filename we'll download the pdf as
    ] 
    return KNOWLEDGE_FILLED_FORM_GENERATOR_URL + "/filled-form?" + queryComponents.join("&")
  }

  async fetchFormTypes(): Promise<FormType[] | undefined> {
    const fullPath = `${AtticusForm.path}/form-types`;
    const response = await network.callGet(fullPath);

    const formTypes: FormType[] = [];
    response?.data?.forEach((formType: any) => {
      formTypes.push(FormType.fromJSON(formType));
    });

    return formTypes;
  }
}
